export const VARIANT_GROUP_IDS = {
  ROOMS: 1
}

export const FACT_ATTRIBUTE_IDS = {
  ATTRIBUTE_NAME: 190,
  CURRENCY_CODE: 613,
  COUNTRY_CODE: 614,
}

export const FACT_IDS = {
  CURRENCY: 917,
  COUNTRY: 916,
}

export const FACT_LABEL_HOVER_COLOR = '#838791'
export const FACT_LABEL_TOOLTIP_MIN_WIDTH = 250
export const FACT_LABEL_TOOLTIP_DELAY = 500

export const FACTSHEET_VALUE_VALIDATION_ERRORS = Object.freeze({
  URL_TOO_LONG: 'URL_TOO_LONG',
  URL_NON_HTTPS: 'URL_NON_HTTPS',
})
